<template>
    <div>
        <div class="card-header">
            <h3 class="card-title">Entradas para la sesión: {{ sesion.fecha }}</h3>
            <div class="form-group my-3">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="ambos">
                    <label class="custom-control-label" for="customSwitch1">Aplicar en ambos</label>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <PricesTableComponent tipo="normal" :evento_id="evento_id" :sesion="sesion" :precios="precios" :ambos="ambos"></PricesTableComponent>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PricesTableComponent from "@/components/backend/eventos/PricesTableComponent";

export default {
    props: ['evento_id', 'sesion', 'precios'],
    data() {
        return {
            ambos: false,
        }
    },
    components: { PricesTableComponent }
}
</script>
